/*
  Add here your own custom javascript codes
*/

console.log("Custom JS!");
const waitForElement = (selector) => {
  return new Promise((resolve) => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element); // Element already exists
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      const foundElement = document.querySelector(selector);
      if (foundElement) {
        observer.disconnect(); // Stop observing once found
        resolve(foundElement);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
};

const checkProductTitleist = document.querySelector('.template-product-titleist');
if(checkProductTitleist){
  waitForElement('.template-product-titleist .btn-atc.rfq-btn')
    .then((element) => {
      console.log('Element found:', element);
      var blockATC = document.querySelector('.template-product-titleist .product-block-atc');
      blockATC.insertAdjacentElement('beforebegin', element);
    })
    .catch((error) => {
      console.error('Error waiting for element:', error);
    });
}